import { TICKET_KIND_LABELS, TICKET_STATUS_LABELS, type TicketKind, type TicketStatus } from '@hearth/shared';
import { clsx } from 'clsx';
import { Bug, CircleHelp, Lightbulb, type LucideIcon, MessageSquare } from 'lucide-react';
import { Badge } from '../../components/ui';

const STATUS_COLORS: Record<TicketStatus, string> = {
  new: 'sky',
  planned: 'violet',
  in_progress: 'amber',
  done: 'emerald',
  declined: 'slate',
};

export const TICKET_KIND_ICONS: Record<TicketKind, LucideIcon> = {
  feature: Lightbulb,
  problem: Bug,
  question: CircleHelp,
  other: MessageSquare,
};

export function TicketStatusBadge({ status, size }: { status: TicketStatus; size?: 'sm' | 'md' }) {
  return (
    <Badge color={STATUS_COLORS[status]} dot size={size}>
      {TICKET_STATUS_LABELS[status]}
    </Badge>
  );
}

export function TicketKindLabel({ kind, className }: { kind: TicketKind; className?: string }) {
  const Icon = TICKET_KIND_ICONS[kind];
  return (
    <span className={clsx('inline-flex items-center gap-1 whitespace-nowrap', className)}>
      <Icon size={12} aria-hidden className="shrink-0" />
      {TICKET_KIND_LABELS[kind]}
    </span>
  );
}
